import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from '@shared/services';
import { genRandomId } from '@shared/utils';
import { environment } from '@env/environment';

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  constructor(private readonly _loading: LoadingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.startsWith('./assets') ||
      request.url === environment.MAINTENANCE_STATUS_ENDPOINT
    ) {
      return next.handle(request);
    }

    const randomId = genRandomId();
    this._loading.showLoadingIndicator(randomId);
    return next
      .handle(request)
      .pipe(finalize(() => this._loading.hideLoadingIndicator(randomId)));
  }
}
